import {
  Box,
  Tab,
  Tabs,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import React, { useState, useMemo } from "react";
import { t, Trans } from "@lingui/macro";
import { useMobile, useWeb3Context } from "src/hooks";
import NoData from "src/assets/images/noData.svg";
import { CustormPagination } from "../index";
import { isPendingTxn, txnButtonTextGeneralPending } from "src/slices/PendingTxnsSlice";
import { LoadingButton } from "@mui/lab";
import { useAppSelector } from "src/hooks";
import dayjs from "dayjs";
import { customNumberFormat, prettyRestakeVestingPeriodByEnd, compareEndTimeFromNow } from "src/helpers";
import { INVITE_PER_PAGE } from "src/constants";
import { getBalances, getRestakingRecordsByPage, loadAccountDetails } from "src/slices/AccountSlice";
import { useDispatch } from "react-redux";
import { logger } from "ethers";
import { releasePrincipal } from "src/slices/ReStakeThunk";
import { loadAppDetails } from "src/slices/AppSlice";
const RecordDataCard = ({ record, index, handleClaim, recordPaused }: any) => {
  const isGtNow = compareEndTimeFromNow(Number(record.endAt));

  const pendingTransactions = useAppSelector(state => {
    return state.pendingTransactions;
  });

  const pendingClaim = () => {
    if (
      isPendingTxn(pendingTransactions, "claim_principal") ||
      isPendingTxn(pendingTransactions, "claim_all_principal")
    ) {
      return true;
    }

    return false;
  };
  const vestingPeriod = () => {
    console.log("vestingPeriod", record, { startAt: Number(record.startAt), duration: Number(record.endAt) });
    // return prettifySeconds(seconds);
    return prettyRestakeVestingPeriodByEnd(Number(record.startAt), Number(record.endAt));
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        borderBottom: "1px solid #2d2d2d",
        py: "20px",
      }}
    >
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{
          mb: "16px",
        }}
      >
        <Typography
          sx={{
            color: "#848e9c",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          <Trans>Time</Trans>
        </Typography>
        <Typography
          sx={{
            color: "#EAECEF",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {record.startAt && dayjs(Number(record.startAt) * 1000).format("YYYY/MM/DD HH:mm:ss")}
        </Typography>
      </Box>

      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{
          mb: "16px",
        }}
      >
        <Typography
          sx={{
            color: "#848e9c",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          <Trans>Restaking(sNVB)</Trans>
        </Typography>
        <Typography
          sx={{
            color: "#EAECEF",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {customNumberFormat(Number(record.total), 4)}
        </Typography>
      </Box>
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{
          mb: "16px",
        }}
      >
        <Typography
          sx={{
            color: "#848e9c",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          <Trans>Fully Vested</Trans>
        </Typography>
        <Typography
          sx={{
            color: "#EAECEF",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {vestingPeriod()}
        </Typography>
      </Box>
      <Box display="flex" alignItems={"center"} justifyContent={"center"}>
        <Box
          sx={{
            width: "100%",
            borderRadius: "6px",
            height: "35px",
            border: "1px solid #8E5318",
            background: "linear-gradient(90deg, #F1F6F2 0%, #EEE099 100%)",
            // boxShadow: "-3px 3px 0px 0px #ECAA00",
            // mr: "10px",
            "&:hover": {
              transform: "scale(1.02)",
            },
          }}
        >
          <LoadingButton
            sx={{
              width: "100%",
              height: "100%",
              background: "transparent",
              "&:hover": {
                background: "transparent",
              },
            }}
            // loading
            loadingPosition="end"
            onClick={() => handleClaim(record, index)}
            variant="contained"
            loading={isPendingTxn(pendingTransactions, "claim_principal") || pendingClaim()}
            disabled={
              isPendingTxn(pendingTransactions, "claim_principal") || pendingClaim() || !isGtNow || recordPaused
            }
          >
            <Typography
              sx={{
                color: "#000",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              {txnButtonTextGeneralPending(pendingTransactions, "claim_principal", t`Claim`)}
            </Typography>
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
};

const RecordTableRow = ({ record, index, handleClaim, recordPaused }: any) => {
  logger.info("RecordTableRow", { record, index, isGt: compareEndTimeFromNow(Number(record.endAt)) });
  const pendingTransactions = useAppSelector(state => {
    return state.pendingTransactions;
  });
  const isGtNow = compareEndTimeFromNow(Number(record.endAt));
  const pendingClaim = () => {
    if (
      isPendingTxn(pendingTransactions, "claim_principal") ||
      isPendingTxn(pendingTransactions, "claim_all_principal")
    ) {
      return true;
    }

    return false;
  };
  console.log(
    " RecordTableRow record",
    { record, startAt: record.startAt },
    dayjs(Number(record.startAt) * 1000).format("YYYY/MM/DD HH:mm:ss"),
  );

  const vestingPeriod = () => {
    console.log("vestingPeriod", record, { startAt: Number(record.startAt), duration: Number(record.endAt) });
    // return prettifySeconds(seconds);
    return prettyRestakeVestingPeriodByEnd(Number(record.startAt), Number(record.endAt));
  };

  return (
    <TableRow>
      <TableCell
        align="left"
        sx={{
          borderBottom: "none",
        }}
      >
        <Typography
          sx={{
            color: "#eaecef",
            fontSize: "16px",
            fontWeight: "500",
            borderBottom: "none",
          }}
        >
          {record.startAt && dayjs(Number(record.startAt) * 1000).format("YYYY/MM/DD HH:mm:ss")}
        </Typography>
      </TableCell>
      <TableCell
        align="left"
        sx={{
          borderBottom: "none",
        }}
      >
        <Typography
          sx={{
            color: "#eaecef",
            fontSize: "16px",
            fontWeight: "500",
            borderBottom: "none",
          }}
        >
          {customNumberFormat(Number(record.total), 4)}
        </Typography>
      </TableCell>
      <TableCell
        align="left"
        sx={{
          borderBottom: "none",
        }}
      >
        <Typography
          sx={{
            color: "#eaecef",
            fontSize: "16px",
            fontWeight: "500",
            borderBottom: "none",
          }}
        >
          {vestingPeriod()}
        </Typography>
      </TableCell>
      <TableCell
        sx={{
          borderBottom: "none",
        }}
      >
        <Box display="flex" alignItems={"center"} justifyContent={"center"}>
          <Box
            sx={{
              width: "113px",
              borderRadius: "6px",
              height: "35px",
              border: "1px solid #8E5318",
              background: "linear-gradient(90deg, #F1F6F2 0%, #EEE099 100%)",
              "&:hover": {
                transform: "scale(1.02)",
              },
            }}
          >
            <LoadingButton
              sx={{
                width: "100%",
                height: "100%",
                background: "transparent",
                "&:hover": {
                  background: "transparent",
                },
              }}
              loadingPosition="end"
              onClick={() => handleClaim(record, index)}
              variant="contained"
              loading={isPendingTxn(pendingTransactions, "claim_principal") || pendingClaim()}
              disabled={
                isPendingTxn(pendingTransactions, "claim_principal") || pendingClaim() || !isGtNow || recordPaused
              }
              // disabled={!isGtTime30}
            >
              <Typography
                sx={{
                  color: "#000",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <Trans>Claim</Trans>
              </Typography>
            </LoadingButton>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

const RestakeTable = ({
  restakingPool90Records,
  restakingPool180Records,
  restakingPool360Records,
  restaking90Paused,
  restaking180Paused,
  restaking360Paused,
}: any) => {
  const { isSmallScreen } = useMobile();
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const { address, chainID, provider } = useWeb3Context();
  logger.info("getRestakingRecordsByPage", { provider, address, chainID });
  const [tab, setTab] = useState(0);
  const pendingTransactions = useAppSelector(state => {
    return state.pendingTransactions;
  });
  const restakingPool180Total = useAppSelector(state => {
    return state.account.restakingPool180Total;
  });
  const restakingPool360Total = useAppSelector(state => {
    return state.account.restakingPool360Total;
  });
  const restakingPool90Total = useAppSelector(state => {
    return state.account.restakingPool90Total;
  });

  const changeTab = (event: React.ChangeEvent<{}>, newTab: number) => {
    setTab(newTab);
    setCurrentPage(1);
  };

  const recordData = useMemo(() => {
    if (tab === 0) {
      return restakingPool360Records;
    } else if (tab === 1) {
      return restakingPool180Records;
    } else {
      return restakingPool90Records;
    }
  }, [tab, restakingPool360Records, restakingPool180Records, restakingPool90Records]);

  const recordPaused = useMemo(() => {
    if (tab === 0) {
      return restaking360Paused;
    } else if (tab === 1) {
      return restaking180Paused;
    } else {
      return restaking90Paused;
    }
  }, [tab, restaking360Paused, restaking180Paused, restaking90Paused]);

  const handleClaim = async (record: any, index: number) => {
    console.log("handleClaim", record, index);
    await dispatch(
      releasePrincipal({
        address,
        provider,
        networkID: chainID,
        poolType: tab,
        ids: [index],
        isAll: false,
      }),
    );
    await Promise.all([
      dispatch(
        getRestakingRecordsByPage({
          address,
          page: 1,
          provider,
          networkID: chainID,
          limit: INVITE_PER_PAGE,
          poolType: [2, 1, 0][tab],
        }),
      ),
      dispatch(
        getBalances({
          address,
          provider,
          networkID: chainID,
        }),
      ),
      dispatch(
        loadAppDetails({
          address,
          provider,
          networkID: chainID,
        }),
      ),
    ]);
    setCurrentPage(1);
  };

  const count = useMemo(() => {
    if (tab === 0) {
      return Math.ceil(restakingPool360Total / INVITE_PER_PAGE);
    } else if (tab === 1) {
      return Math.ceil(restakingPool180Total / INVITE_PER_PAGE);
    } else {
      return Math.ceil(restakingPool90Total / INVITE_PER_PAGE);
    }
  }, [tab, restakingPool360Total, restakingPool180Total, restakingPool90Total]);

  const changePage = (event: any, page: number) => {
    setCurrentPage(page);
    dispatch(
      getRestakingRecordsByPage({
        address,
        page,
        provider,
        networkID: chainID,
        limit: INVITE_PER_PAGE,
        poolType: [2, 1, 0][tab],
      }),
    );
  };

  const pendingClaim = () => {
    if (
      isPendingTxn(pendingTransactions, "claim_principal") ||
      isPendingTxn(pendingTransactions, "claim_all_principal")
    ) {
      return true;
    }

    return false;
  };
  const onClaimAll = async () => {
    console.log("onClaimAll");
    await dispatch(
      releasePrincipal({
        address,
        provider,
        networkID: chainID,
        poolType: tab,
        ids: [],
        isAll: true,
      }),
    );
    dispatch(
      getRestakingRecordsByPage({
        address,
        page: 1,
        provider,
        networkID: chainID,
        limit: INVITE_PER_PAGE,
        poolType: [2, 1, 0][tab],
      }),
    );
    setCurrentPage(1);
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "300px",
        borderRadius: "6px",
        border: "1px solid #2D2D2D",
        background: "#151515",
        px: { xs: "15px", sm: "0" },
        pb: "20px !important",
      }}
    >
      {/* record tab */}
      <Box>
        <Tabs
          value={tab}
          onChange={changeTab}
          sx={{
            borderBottom: "1px solid #2d2d2d",
            "& .MuiTabs-indicator": {
              background: "#fff",
            },
          }}
          variant="scrollable"
        >
          <Tab
            label={t`360Day`}
            sx={{
              color: "#848E9C",
              fontSize: "16px",
              fontWeight: "400",
              textTransform: "capitalize",
              "&.Mui-selected": {
                color: "#EAECEF",
                fontWeight: "600",
              },
            }}
          />
          <Tab
            label={t`180Day`}
            sx={{
              color: "#848E9C",
              fontSize: "16px",
              fontWeight: "400",
              textTransform: "capitalize",
              "&.Mui-selected": {
                color: "#EAECEF",
                fontWeight: "600",
              },
            }}
          />
          <Tab
            label={t`90Day`}
            sx={{
              color: "#848E9C",
              fontSize: "16px",
              fontWeight: "400",
              textTransform: "capitalize",
              "&.Mui-selected": {
                color: "#EAECEF",
                fontWeight: "600",
              },
            }}
          />
        </Tabs>
      </Box>
      {/* record table data */}
      {isSmallScreen ? (
        recordData && recordData.length > 0 ? (
          <Box sx={{ mb: "20px" }}>
            {recordData.map((record: any, _index: number) => (
              <RecordDataCard
                key={_index}
                record={record}
                index={(currentPage - 1) * INVITE_PER_PAGE + _index}
                handleClaim={handleClaim}
                recordPaused={recordPaused}
              />
            ))}
          </Box>
        ) : (
          <Box
            sx={{ width: "100%", height: "330px" }}
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
          >
            <img src={NoData} alt="No Data" />
            <Typography
              sx={{
                pt: 2,
                color: "#C7C8CC",
                fontSize: "12px",
                fontWeight: "400",
              }}
            >
              <Trans>No data</Trans>
            </Typography>
          </Box>
        )
      ) : (
        <Box sx={{ minHeight: "300px", mb: "20px" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{
                      color: "#848E9C",
                      fontSize: "16px",
                      fontWeight: "400",
                      borderBottom: "none",
                    }}
                  >
                    <Trans>Time</Trans>
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      color: "#848E9C",
                      fontSize: "16px",
                      fontWeight: "400",
                      borderBottom: "none",
                    }}
                  >
                    <Trans>Restaking(sNVB)</Trans>
                    {/* <Trans>Destruction WBNB</Trans> */}
                  </TableCell>

                  <TableCell
                    align="left"
                    sx={{
                      color: "#848E9C",
                      fontSize: "16px",
                      fontWeight: "400",
                      borderBottom: "none",
                    }}
                  >
                    <Trans>Fully Vested</Trans>
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      color: "#848E9C",
                      fontSize: "16px",
                      fontWeight: "400",
                      borderBottom: "none",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {recordData && recordData.length > 0 ? (
                  recordData.map((record: any, _index: number) => (
                    <RecordTableRow
                      key={_index}
                      record={record}
                      index={(currentPage - 1) * INVITE_PER_PAGE + _index}
                      handleClaim={handleClaim}
                      recordPaused={recordPaused}
                    />
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      sx={{
                        height: "300px",
                        borderBottom: "none",
                      }}
                    >
                      <Box
                        sx={{ width: "100%", height: "100%" }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                      >
                        <img src={NoData} alt="No Data" />
                        <Typography
                          sx={{
                            pt: 2,
                            color: "#848E9C",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: "400",
                          }}
                        >
                          <Trans>No data</Trans>
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
      {recordData && recordData.length > 0 && (
        <Box
          sx={{
            width: "100%",
          }}
          display="flex"
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {/* {recordData && recordData.length > 0 && ( */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              mb: 2,
            }}
          >
            <CustormPagination
              siblingCount={isSmallScreen ? 0 : 1}
              boundaryCount={1}
              count={count}
              page={currentPage}
              onChange={changePage}
            />
          </Box>
          {/* )} */}
          {/* )} */}

          {/* {recordData && recordData.length > 0 && ( */}
          <Box
            sx={{
              width: { xs: "100%", sm: "290px" },
              borderRadius: "6px",
              height: "44px",
              border: "1px solid #8E5318",
              background: "linear-gradient(90deg, #F1F6F2 0%, #EEE099 100%)",
              // boxShadow: "-3px 3px 0px 0px #ECAA00",
              mb: "10px",
              "&:hover": {
                transform: "scale(1.02)",
              },
            }}
          >
            <LoadingButton
              variant="contained"
              disabled={isPendingTxn(pendingTransactions, "claim_all_principal") || pendingClaim() || recordPaused}
              loading={isPendingTxn(pendingTransactions, "claim_all_principal") || pendingClaim()}
              loadingPosition="end"
              onClick={onClaimAll}
              sx={{
                width: "100%",
                height: "100%",
                background: "transparent",
                color: "#000",
                "&:hover": {
                  background: "transparent",
                },
              }}
            >
              {txnButtonTextGeneralPending(pendingTransactions, "claim_all_principal", t`Claim all`)}
            </LoadingButton>
          </Box>
          {/* )} */}
        </Box>
      )}
    </Box>
  );
};

export default RestakeTable;
